;(function( $, window, document, undefined ){

  var ButtonElement = function( elem, options ){
      this.elem = elem;
      this.$elem = $(elem);
      this.options = options;

      this.cacheTimeout = 60 * 60 * 1000; // 60 mins

      if (this.$elem.length === 0) {
        //no elements to bind to...don't setup button.
        this._init = true;
      }
    };

  // the plugin prototype
  ButtonElement.prototype = {
    defaults: {
      message: 'Button Enabled'
    },

    init: function() {
      if (this._init) {
        return;
      }

      this._init = true;
      this.config = $.extend({}, this.defaults, this.options,
      this.metadata);

      this.processGithubReleaseLinks();

      return this;
    },

    processGithubReleaseLinks: function() {
      var release = this.$elem.data('github-release');

      if (release && release.filename) {
        this.rebuildApiLinks(release).then(function(data) {
          this.findAndReplaceLink(release, data);
        }.bind(this));
      }
    },

    rebuildApiLinks: function(release) {
      var promise = $.Deferred();
      var apiUrl = "https://api.github.com/repos/" + release.owner + "/" + release.repository + "/releases/latest";
      var cacheKey = 'cache-learn-' + this.$elem.attr('id');

      // return sessionStorage cache if present
      if(sessionStorage && (cached = sessionStorage.getItem(cacheKey))) {

        try {

          cached = JSON.parse(cached);

          if(cached.timestamp && Date.now() < cached.timestamp) {
            return promise.resolve(cached.data);
          }

        } catch(e) {}

      }

      $.getJSON(apiUrl).done(function (data) {
        if(sessionStorage) {
          sessionStorage.setItem(cacheKey, JSON.stringify({
            timestamp: Date.now() + this.cacheTimeout,
            data: data
          }));
        }

        promise.resolve(data);
      }.bind(this));

      return promise;
    },

    findAndReplaceLink: function(release, githubResponse) {
      var filename = release.filename;
      // replace the asterisk with a check for any non-whitespace character.
      // will end up looking something like:
      // from: "adafruit_drivers_*.exe"
      // to: /^(adafruit_drivers_){1}[\S]+(.exe){1}$/g
      filename = filename.split("*").map(function(value) {
        return "(" + value + "){1}";
      }).join("[\\S]+");
      filename = '^' + filename + '$';
      var regexp = new RegExp(filename, "g");

      githubResponse.assets.forEach(function(asset) {
        if (asset.name.match(regexp)) {
          // replace the button link with the actual download link of the latest file
          this.$elem.find('a').attr('href', asset.browser_download_url);
        }
      }.bind(this));
    }
  };


  ButtonElement.defaults = ButtonElement.prototype.defaults;

  $.fn.buttonElement = function(options) {
    return this.each(function() {
      new ButtonElement(this, options).init();
    });
  };

  //optional: window.Plugin = Plugin;

})( jQuery, window , document );
